import { render, staticRenderFns } from "./NovaSenha.vue?vue&type=template&id=6df0b7da&scoped=true&"
import script from "./NovaSenha.vue?vue&type=script&lang=js&"
export * from "./NovaSenha.vue?vue&type=script&lang=js&"
import style0 from "./NovaSenha.vue?vue&type=style&index=0&id=6df0b7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0b7da",
  null
  
)

export default component.exports